import React from "react"
import styled from "styled-components"

const BackgroundSection = ({ children }) => (
  <StyledBackgroundSection>{children}</StyledBackgroundSection>
)

const StyledBackgroundSection = styled.div`
  width: 100%;
  background: url("/bg.svg");
  background-position: bottom center;
  background-size: cover;
`

export default BackgroundSection
